<template>
  <div class="col-md-8">
    <div class="card">
      <div class="card-header">
        <!-- <h4 class="card-title mb-0">Historial Plantillas</h4>
        <div class="card-options text-right">demo</div> -->
        <div class="header-top">
          <h4 class="m-0">Lista Participantes Inscritos</h4>
          <!-- <div class="card-header-right-icon">
            <button class="btn btn-default" @click="showModal">
              <i class="fa fa-plus">Agregar Plantilla</i>
            </button>
          </div> -->
        </div>
      </div>
      <div class="table-responsive add-project">
        <table class="table card-table table-vcenter text-nowrap">
          <thead>
            <tr>
              <th>#</th>
              <th>CI - Complemento</th>
              <th>Paterno</th>
              <th>Materno</th>
              <th>Nombre(s)</th>
              <th class="text-center">Asistió</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in paginatedItems" :key="item.id">
              <th>{{ index + 1 + (currentPage - 1) * itemsPerPage }}</th>
              <td>{{ item.id_card }}</td>
              <td>{{ item.flast }}</td>
              <td>{{ item.slast }}</td>
              <td>{{ item.names }}</td>
              <td class="text-center">
                <i class="fa fa-check-circle" v-show="item.is_attendance"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination
        :totalItems="list.length"
        :itemsPerPage="itemsPerPage"
        @page-change="handlePageChange"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import axios from "@/includes/connection";

// openModal
const emit = defineEmits(["openModal", "reload"]);
const props = defineProps({ list: Array });
const showModal = () => {
  //console.log("open modal");
  emit("openModal");
};

const list = computed(() => {
  return props.list;
});

const downloadTemplate = async (id, fileName) => {
  try {
    const response = await axios.get(`/certification/download/${id}`, {
      responseType: "blob", // Important for handling binary data
    });

    // Create a URL for the blob and download it
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName + ".docx"); // Use the actual file name
    document.body.appendChild(link);
    link.click();

    // Clean up
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading template:", error);
  }
};

function formatTimestampToDate(timestamp) {
  const date = new Date(timestamp);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}

//---pagination section
import Pagination from "@/pages/components/Pagination.vue";
let currentPage = ref(1);
let itemsPerPage = ref(10);

let paginatedItems = computed(() => {
  const startIndex = (currentPage.value - 1) * itemsPerPage.value;
  const endIndex = startIndex + itemsPerPage.value;
  return list.value.slice(startIndex, endIndex);
});

function handlePageChange(page) {
  currentPage.value = page;
}
</script>
